<template>
  <div class="collapse">
    <div :class="{ 'collapse-header' : keyCollapse !== null }">
      {{ title }}
    </div>
    <div class="collapse-content">
      <div
        ref="collapseContentBox"
        class="collapse-content-box"
        :class="{
          active: isActive,
          'show-collapse-all': collapseAll && !isActive && getHeightFlag,
          'show-collapse': !collapseAll && isShowCollapseBtn && getHeightFlag,
          'key-collapse-none': keyCollapse === null,
        }"
        :style="collapseHeight === 0 ? [maxHeightStyle] : {maxHeight : collapseHeight + 'px'}"
      >
        <slot></slot>
      </div>
      <div v-if="isShowCollapseBtn && collapseAll" class="collapse-btn flex gap-x-2 my-2 mb-6 btn-collapse" :class="{ 'collapse-btn-all': collapseAll }" @click="onCollapse">
        <span class="icon icon-bor-triangle-down color-item" v-if="collapseAll" :class="{ rotate: isActive }"></span>
        {{ isActive ? "追加のこだわり条件を閉じる" : "こだわり条件を追加する" }}
      </div>
      <div v-if="isShowCollapseBtn && !collapseAll" class="collapse-btn relative" :class="{ 'collapse-btn-all': collapseAll }" @click="onCollapse">
        <span class="icon icon-bor-arrow-down" :class="{ rotate: isActive }" />
        {{ isActive ? "閉じる" : "さらに条件を開く" }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    keyCollapse: {
      type: [String, Number],
      default: 1
    },
    isShowCollapseBtn: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    collapseAll: {
      type: Boolean,
      default: false
    },
    collapseHeight: {
      type: Number,
      default: 0
    },
    getHeightFlag: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      maxHeight: 1200
    }
  },

  computed: {
    currentData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },

    isActive() {
      return this.currentData.some((item) => +item === +this.keyCollapse)
    },

    maxHeightStyle() {
      const data =
        this.isShowCollapseBtn && this.isActive && !this.collapseAll
          ? {
            maxHeight: `${this.maxHeight}px`
          }
          : {}
      return data
    }
  },

  mounted() {
    this.calculateMaxHeight()
  },

  methods: {
    calculateMaxHeight() {
      this.$nextTick(() => {
        const scrollHeight = this.$refs.collapseContentBox.scrollHeight
        this.maxHeight = scrollHeight ? scrollHeight + 50 : scrollHeight
      })
    },
    onCollapse() {
      if (!this.isShowCollapseBtn) return

      const index = this.currentData.findIndex(
        (item) => +item === +this.keyCollapse
      )

      index < 0
        ? this.currentData.push(this.keyCollapse)
        : this.currentData.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse {
  &-header {
    padding: 6px 8px;
    color: rgba(0, 0, 0, 0.85);
    background-color: #e7e7e7;
    font-weight: 700;
    line-height: 22px;
  }

  &-content-box {
    padding: 4px;
    overflow: hidden;
    transition: max-height 0.5s ease;
    &.show-collapse-all {
      max-height: 110px !important;
      &.key-collapse-none {
        max-height: 0px !important;
      }
    }
    &.show-collapse {
      max-height: 128px;
    }
    &.active {
    }
  }

  &-btn {
    @apply flex justify-center items-center gap-x-1 cursor-pointer;
    font-weight: 700;
    padding: 0.5rem 0;

    .icon {
      font-size: 8px;
      font-weight: 700;
      transition: all 0.5s;

      &.rotate {
        transform: rotateX(180deg);
      }
    }
  }

  &-btn-all {
    @apply flex justify-center items-center gap-x-1 cursor-pointer;
    font-weight: 700;
    padding: 0.5rem 0;
    border-radius: 60px;
    background-color: #E7E7E7;

    .icon {
      font-size: 8px;
      font-weight: 700;
      transition: all 0.5s;
      margin-top: 2px;

      &.rotate {
        transform: rotateX(180deg);
      }
    }
  }
  &-btn-all:hover {
    color: #dc6718
  }
}

.color-item {
  color: #5190d3
}

.collapse-btn-all:hover span {
  color: #dc6718 !important;
}

</style>
